/**
 * Main File
 */
import Vue from 'vue';

/**
 * Plugins
 */
// import { datadogRum } from '@datadog/browser-rum';
import 'promise-polyfill/src/polyfill';
// import '@/plugins/tawk';

import '@/plugins/vuex';
import '@/plugins/config';
import '@/plugins/axios';
import { i18n } from '@/plugins/vue-i18n';
import '@/plugins/bootstrap';
import '@/plugins/font-awesome';
import '@/plugins/vee-validate';
import '@/plugins/vue-tabs';
import '@/plugins/toast';
import '@/plugins/vue-modal';
import '@/plugins/vue-event-bus';
import '@/plugins/v-calendar';
import '@/plugins/v-click-outside';
import '@/plugins/vue-infinite-scroll';
import '@/plugins/vue-upload-component';
import '@/plugins/driver';

import '@/utils/numeric';
import { initializePreloading } from '@/utils/route-preloader';
/**
 * Styling
 */
import '@/assets/style/main.sass';
import '@/store/proxies/interceptors/index';
import App from './app';
import { router } from './routes';
import store from './store';

// datadogRum.init({
//   applicationId: '4bbc5509-56fc-4e56-aa89-bc1d57e88649',
//   clientToken: 'pub7c8b3e1008f5c8e3a64a136e0f938068',
//   // site refers to the Datadog site parameter of your organization
//   // see https://docs.datadoghq.com/getting_started/site/
//   site: 'us5.datadoghq.com',
//   service: 'pinance',
//   env: process.env.DATADOG_ENV,
//   // Specify a version number to identify the deployed version of your application in Datadog
//   // version: '1.0.0',
//   sessionSampleRate: 100,
//   sessionReplaySampleRate: 50,

//   trackResources: true,
//   trackLongTasks: true,
//   trackUserInteractions: true,

//   defaultPrivacyLevel: 'mask-user-input',
// });

store.dispatch('auth/check');

// Initialize route preloading for better mobile performance
initializePreloading();

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js